// React 18 passes every error an error boundary catches to console.error as
// well, and RUM collects that as a second, `console`-source copy of the error
// the boundary already reported (ECDEX-3989). The boundary marks the error
// object here, before React logs it, so RUM's beforeSend can drop that copy.
const caughtErrors = new WeakSet<object>();

export const markCaughtByBoundary = (error: unknown): void => {
  if (error !== null && typeof error === 'object') caughtErrors.add(error);
};

export const wasCaughtByBoundary = (error: unknown): boolean =>
  error !== null && typeof error === 'object' && caughtErrors.has(error);
